export default {"src":"/_next/static/media/ElementFI.c804c4ff.svg","height":27,"width":125,"blurWidth":0,"blurHeight":0};